const KEY = 'ss_session_key';
const OWNER = 'ss_session_user_id';

// Reuse a legacy diagnostic id only after the authenticated, user-filtered
// lookup proves ownership. Replacing it with insert-then-delete could count
// this browser twice and evict another device if the deletion failed.
export async function registerBrowserSession(userId, client, isCurrent, storage = sessionStorage) {
  if (!userId) throw new Error('A user is required for a tracked browser session');
  if (!isCurrent()) return null;
  const previousKey = storage.getItem(KEY);
  let key = previousKey && storage.getItem(OWNER) === userId ? previousKey : null;
  if (!key && previousKey) {
    const { data, error } = await client.from('user_sessions')
      .select('session_id').eq('user_id', userId).eq('session_id', previousKey).maybeSingle();
    if (!isCurrent()) return null;
    if (error) throw error;
    if (data?.session_id === previousKey) key = previousKey;
  }
  if (!key) {
    key = typeof crypto?.randomUUID === 'function'
      ? crypto.randomUUID()
      : `ss-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }
  // Reserve the owned key before awaiting the write so a newer notification
  // for this account uses the same id. A different account still gets its own.
  storage.setItem(KEY, key);
  storage.setItem(OWNER, userId);
  const { error } = await client.from('user_sessions').upsert({
    user_id: userId,
    session_id: key,
    device_info: navigator.userAgent,
    last_seen_at: new Date().toISOString(),
  }, { onConflict: 'session_id' });
  if (!isCurrent()) return null;
  if (error) throw error;
  return key;
}

export function readBrowserSessionKey(userId, storage = sessionStorage) {
  return storage.getItem(OWNER) === userId ? storage.getItem(KEY) : null;
}
